import { Helmet } from "react-helmet";
import Header from "../../layout/Header";
import Footer from "../../layout/Footer";
import Pagebanner from "../../layout/Banner";
import ContactForm from "../../Components/HomeSections/ContactForm";

const ContactUS = () => {
  const brandGold = "#E3B66B";
  const darkGreen = "#0A1D1B";
  return (
    <>
      <Helmet>
        <title>Contact Us - Nyaysakti Chambers</title>
        <meta
          name="description"
          content="Get in touch with Nyaysakti Chambers. Fill out our contact form to consult with our expert lawyers, ask questions, or request legal services."
        />
        <meta
          name="keywords"
          content="Contact Nyaysakti, Legal Consultation, Law Firm Contact, Lawyer Inquiry, Legal Services Contact"
        />
        <noscript>
          Please enable JavaScript to view this website properly.
        </noscript>
      </Helmet>

      <Header />
      <Pagebanner title="Contact Us" />
      <ContactForm />

      {/* Map Section */}
      <section className={`bg-[${darkGreen}] py-12 px-6 md:px-12`}>
        <div
          className="max-w-7xl mx-auto rounded-lg overflow-hidden shadow-lg border-2"
          style={{ borderColor: brandGold }}
        >
          <iframe
            title="Nyaysakti Chambers Location"
            src="https://www.google.com/maps/embed?pb=!1m12!1m8!1m3!1d14021.625328872331!2d77.214741!3d28.527504!3m2!1i1024!2i768!4f13.1!2m1!1sChamber%20No.%20%3A652%2C%206th%20Floor%2C%20Lawyers%20Block%2C%20Saket%20Court%20Complex%2C%20New%20Delhi%20-110017!5e0!3m2!1sen!2sus!4v1771651578572!5m2!1sen!2sus"
            width="100%"
            height="450"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default ContactUS;

